import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setAdministracaoConsultaBem: ['administracao'],
    setDescricaoModeloConsultaBem: ['descricaoModelo'],
    setAnoModeloConsultaBem: ['anoModelo'],
    setPlacaConsultaBem: ['placa'],
    setCodigoSituacaoLegalConsultaBem: ['codigoSituacaoLegal'],
    setIdentificacaoConsultaBem: ['identificacao'],
    limpaFiltroConsultaBem: [],
    receberFiltroConsultaBem: ['filtroRecebido'],
})

const INITIAL_STATE = {
    administracao: [],
    descricaoModelo: '',
    anoModelo: '',
    placa: '',
    codigoSituacaoLegal: [],
    identificacao: '',
}

const setAdministracao = (state = INITIAL_STATE, action) => {
    return { ...state, administracao: action.administracao }
}

const setDescricaoModelo = (state = INITIAL_STATE, action) => {
    return { ...state, descricaoModelo: action.descricaoModelo }
}

const setAnoModelo = (state = INITIAL_STATE, action) => {
    return { ...state, anoModelo: action.anoModelo }
}

const setPlaca = (state = INITIAL_STATE, action) => {
    return { ...state, placa: action.placa }
}

const setCodigoSituacaoLegal = (state = INITIAL_STATE, action) => {
    return { ...state, codigoSituacaoLegal: action.codigoSituacaoLegal }
}

const setIdentificacao = (state = INITIAL_STATE, action) => {
    return { ...state, identificacao: action.identificacao }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_ADMINISTRACAO_CONSULTA_BEM]: setAdministracao,
    [Types.SET_DESCRICAO_MODELO_CONSULTA_BEM]: setDescricaoModelo,
    [Types.SET_ANO_MODELO_CONSULTA_BEM]: setAnoModelo,
    [Types.SET_PLACA_CONSULTA_BEM]: setPlaca,
    [Types.SET_CODIGO_SITUACAO_LEGAL_CONSULTA_BEM]: setCodigoSituacaoLegal,
    [Types.SET_IDENTIFICACAO_CONSULTA_BEM]: setIdentificacao,
    [Types.LIMPA_FILTRO_CONSULTA_BEM]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_BEM]: receberFiltro,
})
